export const populateAddToCartModal = (sparePart) => {
    const addToCartModalElement = document.getElementById('addToCartModal');

    if (!sparePart || !addToCartModalElement)
        return;
    
    const lblProductName = addToCartModalElement.querySelector('.product-detail-modal-product-name');
    const lblWebTitle2 = addToCartModalElement.querySelector('.product-detail-modal-webtitle2');
    const lblPrice = addToCartModalElement.querySelector('.cart-modal-price');
    const imgProductImage = addToCartModalElement.querySelector('.product-detail-modal-image');
    const btnGotoCart = addToCartModalElement.querySelector('.btn-goto-cart');
    const btnGotoCheckout = addToCartModalElement.querySelector('.btn-goto-checkout');

    lblProductName.innerHTML = sparePart.Name;
    lblWebTitle2.innerHTML = sparePart.Webtitle2 || '';
    lblPrice.innerHTML = sparePart.PriceFormatted;
    btnGotoCart.href = sparePart.CartPage;
    btnGotoCheckout.href = sparePart.CheckoutPage;

    if (sparePart.Image) {
        imgProductImage.src = sparePart.Image;
        imgProductImage.alt = sparePart.ImageAlt;
    } else {
        imgProductImage.classList.add('invisible');
    }
}

export const getSparePartAddToCartButtonText = (sparePart) => {

    if(sparePart.ButtonType === "InStock"){
        return "Add to cart";
    }
    return "Out of stock";
}
export const getSparePartAddToCartButtonClasses = (sparePart) => {

    if(sparePart.ButtonType === "InStock"){
        return "btn thule-btn-default";
    }
    return "btn";
}